import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Events, Content, NavController, NavParams } from 'ionic-angular';
import { ResumeService } from '../../../../../../UI/src/app/shared/resume/resume.service';
import { AddResumeComponent } from '../../authentication/components/add-resume/add-resume.component';
import { AuthenticationComponent } from '../../authentication/authentication.component';
import { ReviewCandidateProfileComponent } from '../../review-candidate-profile/review-candidate-profile.component';
import { ToastControllerService } from '../../../../providers/toast-controller.service';
import { Toast508Service } from '../../../../providers/toast-508.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../../../../UI/src/app/shared/authentication/authentication.service';

@Component({
  selector: 'page-edit-resume',
  templateUrl: 'resume.component.html'
})
export class ResumeEditComponent implements OnInit, OnDestroy {
  @Input() content: Content;
  public configData: any;
  public resume: any;
  public profileData: any;
  public expanded = false;  
  private alive = true;
  private resumeOptions: any;
  public resumeAction: any;   
  public editResume: boolean = false;
  public createResume: boolean = false;
  public reviewResume: boolean = false;
  public isInititalCreation: boolean = false;
  public translations: any;

  constructor(
    public events: Events,
    public resumeService: ResumeService,
    public navCtrl: NavController ,
    public navParams: NavParams,
    private toastService: ToastControllerService,
    private translate: TranslateService,
    private toast508Service: Toast508Service,
    private authenticationService: AuthenticationService,   
  ) {
    this.events.subscribe('updateNewResumeData', (data) => {
      this.loadUserData();
    });
    this.events.subscribe('filterResumeTimeLine', (data) => {
      this.filterItem(data);
    });
    this.translate.get(['CAREER_PRIMARY_RESUME_NAME', 'CAREER_NO_RESUME_MESSAGE', 'CAREER_FAILED_MESSAGE'])
    .subscribe((obj) => {
      this.translations = obj;
    });
    this.resumeAction = this.resumeService.getResumeAction();
    this.isInititalCreation = this.resumeAction.isInititalCreation;
    if (this.resumeAction.action == 'CREATE_RESUME') {
      this.createResume = true;
      this.editResume = false;
      this.reviewResume = false;
    }
    else if (this.resumeAction.action == 'EDIT_RESUME') {
      this.createResume = false;
      this.editResume = true;
      this.reviewResume = false;
    }
    else if (this.resumeAction.action == 'REVIEW_RESUME') {
      this.createResume = false;
      this.editResume = false;     
      this.reviewResume = true;
    }
  }

  ngOnInit() {
    this.loadConfigurationData();
    if(!this.resume) {
      if (this.authenticationService.isAppliedwithLinkedIn && !this.authenticationService.isResumeRequired) {
         this.resume = this.resumeService.getResume();
          if (this.resume.id > 0) {
            this.resumeService.getResumeDataByID(this.resume.id)
            .takeWhile(() => this.alive)
            .subscribe(data => {
                this.resume = data;
            });
            }
     }
      else {
        this.loadUserData();
      }
    } 
  }

  ngOnDestroy() {
    this.alive = false;
  }

  filterItem(event) {
    this.expandTimeline();
    setTimeout(() => { this.content.scrollToBottom(800); }, 300);
  }

  resumeImport() {
    this.navCtrl.push(AddResumeComponent, true);
  }

  expandAll() {
    this.expanded = !this.expanded;
    for (var i = 0; i < this.configData.sections.length; i++) {
      for (var j = 0; j < this.configData.sections[i].sections.length; j++) {
        this.configData.sections[i].sections[j].expand = this.expanded;
        if(i == 0 && j == 0){
          let elm = document.getElementById(this.configData.sections[i].sections[j].title);
          if(elm)
            elm.focus();
        }
      }
    }
  }

  private expandTimeline() {
    for (var i = 0; i < this.configData.sections.length; i++) {
      for (var j = 0; j < this.configData.sections[i].sections.length; j++) {
        if (this.configData.sections[i].sections[j].name == 'TIMELINE')
          this.configData.sections[i].sections[j].expand = true;
      }
    }
  }

  private loadUserData() {
    this.resumeService.getResumeData()
      .takeWhile(() => this.alive)
      .subscribe(data => {
        this.resume = data;
        if (this.resume === 'NO_RESUME' || this.resume === null) {
          const alertData = { message: this.translations.CAREER_NO_RESUME_MESSAGE, type: 'error' };
          this.toastService.presentToast(alertData);
          this.toast508Service.toFocus();          
        }
        //incase of fresh load no event subscribers, otherwise existing elements will get refreshed. 
        this.events.publish('refreshEditResumeData', true);
      }, error => {
        console.log("error in fetching resume data");
      });
  }

  private loadConfigurationData() {
    this.resumeService.getResumeConfigData()
      .takeWhile(() => this.alive)
      .subscribe(data => {
        this.configData = data;
        try {
          this.configData.sections[0].sections[0].expand = true;
        } catch (e) {
          console.log("cannot expand first section");
        }
      }, error => {
        console.log("error in fetching resume config data");
      });

    this.resumeService.getAllResumeOptions()
      .takeWhile(() => this.alive)
      .subscribe(data => {
        this.resumeOptions = data;
      });
  }

  cancelCreateResume() {
    this.navCtrl.pop();
  }

  submitCreatedResume() {    
    if(this.resumeAction.isInititalCreation && (this.resumeAction.navigatedFrom === "CandidateProfileComponent" || this.resumeAction.navigatedFrom === "JobDetailsPage" || this.resumeAction.navigatedFrom === "SigninComponent"))  {
      this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: this.resumeAction.isInititalCreation, isJobApply: this.resumeAction.isJobApply, showNavbar: false});
      this.navCtrl.push(AuthenticationComponent, { "action": "REVIEW_RESUME" });
    }    
    else{
      this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: this.resumeAction.isInititalCreation, isJobApply: this.resumeAction.isJobApply, showNavbar: true});
      this.navCtrl.push(ReviewCandidateProfileComponent)
    }
    this.bringFocusTo('spStepsDate');    
  }

  
  bringFocusTo(elementId) {
    const element = document.getElementById(elementId);
    setTimeout(() => {
      element.focus();
    }, 500);    
    return true;
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/resume/resume.component.ts